package com.eladfinish.bible.contest.constants.strings

import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.persistentListOf

/** "ראשון" has no in-text marker — it is the start of the reading, so tapping it scrolls to the top. */
const val RISHON_ALIYAH_LABEL = "ראשון"

/** The only aliyah whose in-text marker is LOCALIZED (see [aliyahMarkerLabel]). */
const val HAFTARAH_ALIYAH_LABEL = "הפטרה"

val aliyotParasha: ImmutableList<String> =
    persistentListOf(
        "כהן",
        "לוי",
        "ישראל",
        RISHON_ALIYAH_LABEL,
        "שני",
        "שלישי",
        "רביעי",
        "חמישי",
        "שישי",
        "שביעי",
        "מפטיר",
        HAFTARAH_ALIYAH_LABEL,
    )

/**
 * Maps a "בחר עלייה" dialog label to the marker label embedded in the displayed text.
 * All aliyah markers are hardcoded Hebrew (MarkAliyotUseCase) except the haftarah marker, which
 * HaftarotUseCase embeds LOCALIZED (e.g. "[Haftarah]" in English) — so the scroll needle for
 * הפטרה must be built from the same localized string, or GoToMarkerController won't find it.
 */
fun aliyahMarkerLabel(aliyahLabel: String, localizedHaftarah: String): String =
    if (aliyahLabel == HAFTARAH_ALIYAH_LABEL) localizedHaftarah else aliyahLabel
